import React from "react";
import {Link} from "react-router-dom";

class Promotion extends React.Component {
  render() {
    const clearStyle = {
      clear: "both"
    };
    const PaddingStyle = {
      paddingLeft: "5%",
      paddingRight: "5%"
    };

    const strongStyle = {
      fontSize: "1.2em"
    };

    const strongStyleBlue = {
      fontSize: "1.2em",
      color: "#0076be"
    };
    return (

        <section className="section app-seciton" style={{background: "url(../images/promo-back.jpg)", padding: "145px 0"}}>

          <div className="container">
            <div className="row">

              <div className="col-lg-8">
                <div className="text-left">
                  <h4 className="SansSerif bold600">Customer Value</h4>
                  <div style={{ clear: "both", height: "10px" }} />
                  <h1 className="Title bold600">Free Shipping.<br/>
                    <span className="d-break">Unbelievable Data Pricing.</span>
                  </h1>
                  <div className="col-lg-12 no-padding">
                    <h5 className="SansSerif"><strong className="point-orange">50GB</strong> U.S. Data at 4G/LTE<small>*</small> for <strong className="point-orange">$50</strong></h5>
                    <h5 className="SansSerif"><strong className="point-orange">100GB</strong> U.S. Data at 4G/LTE<small>*</small> for <strong className="point-orange">$90</strong></h5>
                  </div>

                  <div style={{ clear: "both", height: "30px" }} />

                  <div className="app-btn">
                    <a className="btn btn-orange" href="/sale">SEE MORE</a>
                  </div>

                  <div style={{ clear: "both", height: "30px" }} />

                  <div>
                    <small>*may experience slow speeds in times of congestion.</small>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
              </div>

            </div>
          </div>
        </section>
    );
  }
}

export default Promotion;



// WEBPACK FOOTER //
// ./src/layout/Homepromo.js